import type { ReactNode } from "react";

import { LoadingValue } from "~/modules/dashboard/components/LoadingValue.tsx";
import { formatTrackedDays } from "~/modules/timeTracking/utils/timeTrackingUtils.ts";

type Props = {
	title: string;
	icon: ReactNode;
	trackedMinutes: number;
	trackedMinutesAreLoading: boolean;
};

// The Sales and Intern cards show for a user who is not a freelancer, and they read the dashboard user, not
// the signed-in user, so the dev switch shows the card of the picked user. They have no lock, because the
// closing read has one `nonProject` part for Intern, Sales and part time: a lock on one card would also
// close the other two types. They show also without a project, and they show line 1 only: a type has no
// budget, so it has no remaining days.
export function TypeCard({ title, icon, trackedMinutes, trackedMinutesAreLoading }: Props) {
	return (
		<li className="flex min-w-0 flex-col overflow-hidden rounded-lg border border-gray-200 bg-white">
			<div className="flex items-center gap-3 border-b border-gray-200 bg-gray-50 px-3 py-2.5">
				{/* The colours match the icons of the figure rows. The cart icon cuts its badge out with
				    `--icon-cutout`, so the cut takes the colour of the circle. */}
				<div className="flex size-9 shrink-0 items-center justify-center rounded-full bg-primary-500 fill-current text-white [--icon-cutout:theme(colors.primary-500)]">
					{icon}
				</div>
				<h4 className="flex min-h-8 min-w-0 flex-1 items-center text-xs font-semibold leading-4 text-gray-900">
					<span className="line-clamp-2">{title}</span>
				</h4>
			</div>
			<dl className="flex flex-col gap-1 px-3 py-2.5 text-xs md:py-4">
				<div className="flex items-center justify-between gap-3">
					<dt className="text-gray-700">Gebuchte Tage in diesem Monat</dt>
					<dd className="font-semibold text-gray-900">
						{trackedMinutesAreLoading ? <LoadingValue size="sm" /> : formatTrackedDays(trackedMinutes)}
					</dd>
				</div>
			</dl>
		</li>
	);
}
